import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { BasicContext } from "../App";
import $ from "jquery";
import { validatePassword } from "../commonData";
import Password from "../components/inputs/Password";
import OnlyLogoNavbar from "../components/navbars/OnlyLogoNavbar";
import { Checkbox } from "semantic-ui-react";
import PrivacyPolicy from "../components/buttons/PrivacyPolicy";
import { postMethod } from "../requests";
import ModalWithEmail from "../components/modals/ModalWithEmail";
import ContactModal from "../components/modals/ContactModal";

const ActivateAccount = () => {
    const { t } = useTranslation();
    const [showAlert, setShowAlert] = useState(false);
    const [account, setAccount] = useState(null);
    const { setAlerts, logout, checkServerData, setLoading, loading } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    let location = useLocation();
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const [showContactModal, setShowContactModal] = useState(false);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (account.show.passwords) {
            if (account.password.length === 0 || !account.password.replace(/\s+/, "")) {
                $("#accountPassword").addClass("is-invalid");
                errors.push(t("error.emptyFirstPassword"));
            } else if (!validatePassword(account.password)) {
                $("#accountPassword").addClass("is-invalid");
                errors.push(t("error.invalidPassword"));
            }

            if (account.repeatPassword.length === 0 || !account.repeatPassword.replace(/\s+/, "")) {
                $("#accountRepeatPassword").addClass("is-invalid");
                errors.push(t("error.emptySecondPassword"));
            } else if (!validatePassword(account.repeatPassword)) {
                $("#accountRepeatPassword").addClass("is-invalid");
                errors.push(t("error.invalidPassword"));
            }

            if (account.password !== account.repeatPassword) {
                $("#accountPassword").addClass("is-invalid");
                $("#accountRepeatPassword").addClass("is-invalid");
                errors.push(t("error.passwordsAreNotTheSame"));
            }
        }
        if (account.show.regulations && !account.regulations) {
            $("#registerFormRegulations").addClass("is-invalid");
            errors.push(t("error.notCheckedRegulations"));
        }
        if (account.show.rodo && !account.rodo) {
            $("#registerFormRodo").addClass("is-invalid");
            errors.push(t("error.notCheckedRodo"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.activatingAccount") }]);
            setBlockForm(true);
            activateAccount();
        }
    };

    const activateAccount = async () => {
        const res = await postMethod("/activate-account", { account: account });

        if (checkServerData(res)) {
            setAlerts(
                !res.data.studentNeededApprove
                    ? [{ variant: "success", message: t(`success.accountActivated`), fading: 2500, id: "activated" }]
                    : [
                          { variant: "success", message: t(`success.accountActivated`), fading: 2500, id: "activated" },
                          { variant: "info", message: t(`info.activatedAccount`), contactModal: true },
                      ]
            );
            navigate("/app");
        } else setBlockForm(false);
    };

    const checkLinkValidation = async (link) => {
        const res = await postMethod("/check-link-is-valid", { link: link });

        if (res.status !== 200) {
            setShowAlert({ variant: "danger", message: t(`error.${res.response ? res.response.data.code : res.data ? res.data.code : res.code}`) });
            setLoading(false);
        } else {
            const accountData = res.data.accountData;
            setAccount({
                user_name: accountData.user_name,
                user_id: accountData.user_id,
                show: {
                    passwords: accountData.user_password ? false : true,
                    regulations: accountData.user_terms_agreement === "Y" ? false : true,
                    rodo: accountData.user_rodo_agreement === "Y" ? false : true,
                    ecc: accountData.user_ecc_agreement === "Y" ? false : true,
                    newsletter: accountData.user_newsletter_agreement === "Y" ? false : true,
                },
                password: "",
                repeatPassword: "",
                regulations: accountData.user_terms_agreement === "Y" ? true : false,
                rodo: accountData.user_rodo_agreement === "Y" ? true : false,
                ecc: accountData.user_ecc_agreement === "Y" ? true : false,
                newsletter: accountData.user_newsletter_agreement === "Y" ? true : false,
            });
        }
    };

    useEffect(() => {
        if (account && loading) setLoading(false);
        // eslint-disable-next-line
    }, [account]);

    useEffect(() => {
        $("main").css("min-height", `${window.innerHeight - $("#footerMain").outerHeight() - 61}px`);
        logout("noAlertActivateAccount");

        if (location.pathname && location.search) {
            checkLinkValidation(location.pathname + location.search);
        } else {
            setShowAlert({ variant: "danger", message: t("error.linkIsInvalid") });
            setLoading(false);
        }

        // eslint-disable-next-line
    }, []);

    const sendActivationLinkAgain = async (passData) => {
        const res = await postMethod("/send-activation-link", { userEmail: passData.username, token: passData.token });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 2500, id: "emailSent" }]);
            navigate("/app");
        } else setBlockForm(false);
    };

    return (
        <Fragment>
            <OnlyLogoNavbar />
            <main>
                <Container id="activateAccount">
                    {loading ? (
                        <Row>
                            <Col xs={12} className="text-center mt-5">
                                <h1 className="h3">{t("loadingData")}</h1>
                            </Col>
                        </Row>
                    ) : showAlert ? (
                        <Row>
                            <Col xs={12} className="my-3">
                                <Alert variant={showAlert.variant}>
                                    <p>
                                        <FontAwesomeIcon icon={showAlert.icon} className="me-2" /> {showAlert.message}
                                    </p>
                                    {showAlert.variant !== "success" && (
                                        <p>
                                            <Button variant={`outline-${showAlert.variant}`} onClick={() => setShowContactModal(true)} className="d-inline-block">
                                                {t("menu.contact")}
                                            </Button>
                                        </p>
                                    )}
                                    {showAlert.message === t("error.expiredLink") && (
                                        <Button variant={`outline-${showAlert.variant}`} onClick={() => setShowModal(true)}>
                                            {t("registerForm.sendActivationLink")}
                                        </Button>
                                    )}
                                </Alert>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col className="border shadow my-lg-5" xs={12} lg={{ span: 8, offset: 2 }}>
                                <Row>
                                    <Col className="p-3 bg-darker">
                                        <div className="text-center">
                                            <h2 className="h3 mt-lg-5 mt-3 mb-3">{t("activateAccount.title")}</h2>
                                            <p className="mb-4">{t("activateAccount.text", account.user_name)}</p>
                                        </div>
                                        <Form onSubmit={checkValidation}>
                                            {/* only for disabling warning: "Password forms should have (optionally hidden) username fields for accessibility:"*/}
                                            <input type="password" name="password" autoComplete="username password" style={{ display: "none" }} />
                                            {account.show.passwords && (
                                                <>
                                                    <Form.Group controlId="accountPassword">
                                                        <div className="mb-1">
                                                            <Password
                                                                autoComplete="new-account"
                                                                value={account.password}
                                                                onChange={(e) => {
                                                                    setAccount({ ...account, password: e.target.value });
                                                                    $("#accountPassword").removeClass("is-invalid");
                                                                }}
                                                                disabled={blockForm}
                                                                btnID="showPass"
                                                                label={t("password")}
                                                                helper={t("account.passwordHelper")}
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                    <Form.Group className="mb-3" controlId="accountRepeatPassword">
                                                        <Password
                                                            autoComplete="new-account"
                                                            value={account.repeatPassword}
                                                            onChange={(e) => {
                                                                setAccount({ ...account, repeatPassword: e.target.value });
                                                                $("accountRepeatPassword").removeClass("is-invalid");
                                                            }}
                                                            disabled={blockForm}
                                                            btnID="repeatPass"
                                                            rpp
                                                        />
                                                    </Form.Group>
                                                </>
                                            )}
                                            {account.show.regulations && (
                                                <Form.Group className="mb-3">
                                                    <Checkbox
                                                        label={
                                                            <label className="form-label">
                                                                {t("registerForm.regulations")} <span className="text-danger">*</span>
                                                                <br />
                                                                <a href="/files/Regulamin-PT-2025.pdf" target="_blank">
                                                                    {t("studioRegulations")}
                                                                </a>
                                                            </label>
                                                        }
                                                        checked={account.regulations}
                                                        onChange={() => {
                                                            setAccount({ ...account, regulations: !account.regulations });
                                                            $("#registerFormRegulations").removeClass("is-invalid");
                                                        }}
                                                        id="registerFormRegulations"
                                                    />
                                                </Form.Group>
                                            )}
                                            {account.show.rodo && (
                                                <Form.Group className="mb-3">
                                                    <Checkbox
                                                        label={
                                                            <label className="form-label">
                                                                {t("registerForm.rodo")} <span className="text-danger me-3">*</span>
                                                                <PrivacyPolicy />
                                                            </label>
                                                        }
                                                        checked={account.rodo}
                                                        onChange={() => {
                                                            setAccount({ ...account, rodo: !account.rodo });
                                                            $("#registerFormRodo").removeClass("is-invalid");
                                                        }}
                                                        id="registerFormRodo"
                                                    />
                                                </Form.Group>
                                            )}
                                            {account.show.ecc && (
                                                <Form.Group className="mb-3">
                                                    <Checkbox
                                                        label={<label className="form-label">{t("registerForm.ecc")}</label>}
                                                        checked={account.ecc}
                                                        onChange={() => {
                                                            setAccount({ ...account, ecc: !account.ecc });
                                                            $("#registerFormEcc").removeClass("is-invalid");
                                                        }}
                                                        id="registerFormEcc"
                                                    />
                                                </Form.Group>
                                            )}
                                            {account.show.newsletter && (
                                                <Form.Group className="mb-3">
                                                    <Checkbox
                                                        label={<label className="form-label">{t("registerForm.newsletter")}</label>}
                                                        checked={account.newsletter}
                                                        onChange={() => {
                                                            setAccount({ ...account, newsletter: !account.newsletter });
                                                            $("#registerFormNewsletter").removeClass("is-invalid");
                                                        }}
                                                        id="registerFormNewsletter"
                                                    />
                                                </Form.Group>
                                            )}

                                            <div className="text-center">
                                                <Button type="submit" className="my-3">
                                                    {t("activateAccount.submitBtn")}
                                                </Button>
                                            </div>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    )}
                </Container>
            </main>

            {showModal && (
                <ModalWithEmail
                    blockForm={blockForm}
                    onClose={() => setShowModal(false)}
                    onProceed={(data) => {
                        setBlockForm(true);
                        sendActivationLinkAgain(data);
                    }}
                    translate="sendActivationLinkModal"
                    show={true}
                />
            )}
            {showContactModal && <ContactModal onClose={() => setShowContactModal(false)} />}
        </Fragment>
    );
};

export default ActivateAccount;
